import { ServiceProvider } from '../types/firestore';
import { resolveServiceVerificationStatus } from './serviceVerification';

type ProviderEligibilityInput = Partial<ServiceProvider> | null | undefined;

/**
 * Provider is discoverable/publicly visible when profile is verified.
 * Test providers can be visible in discovery/profile, but they are non-operational.
 */
export const isDiscoverableServiceProvider = (provider: ProviderEligibilityInput): boolean => {
  if (!provider) return false;
  return provider.isVerified === true && resolveServiceVerificationStatus(provider) === 'approved';
};

/**
 * Provider is operational for real request flow when:
 * - profile is verified
 * - provider is not marked as test data
 */
export const isOperationalServiceProvider = (provider: ProviderEligibilityInput): boolean => {
  if (!provider) return false;
  return isDiscoverableServiceProvider(provider) && provider.isTestData !== true;
};
